import React, { useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import MedicationSheetList from "../pages/Phase-05/MedicationSheet/MedicationSheetList";
import {
  fetchMedicationSheets,
  deleteMedicationSheet,
  clearError,
} from "../store/slices/medicationSheetsSlice";

const MedicationSheets = () => {
  const navigate = useNavigate();
  const { patientId } = useParams(); // Optional: for patient-specific list
  const dispatch = useDispatch();

  const { medicationSheets, isLoading, error } = useSelector(
    (state) => state.medicationSheets
  );

  // Permissions (replace with real auth later)
  const canManage = true;
  const canCreate = true;
  const canEdit = true;
  const canDelete = true;

  // Fetch on mount
  useEffect(() => {
    dispatch(clearError());
    dispatch(fetchMedicationSheets(patientId || null));
  }, [dispatch, patientId]);

  // Routing handlers
  const handleAdd = () => navigate("/phase05/medication-sheet/add");
  const handleEdit = (id) => navigate(`/phase05/medication-sheet/edit/${id}`);

  // Delete handler
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This Medication Sheet will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await dispatch(deleteMedicationSheet(id)).unwrap();
        Swal.fire("Deleted!", "Record has been removed.", "success");
      } catch (err) {
        Swal.fire("Error", err || "Failed to delete.", "error");
      }
    }
  };

  if (!canManage) {
    return (
      <Navigate
        to="/dashboard"
        state={{ error: "You do not have permission to manage Medication Sheets." }}
        replace
      />
    );
  }

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />

        {/* Error Alert */}
        {error && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>Error:</strong> {error}
            <button
              type="button"
              className="btn-close"
              onClick={() => dispatch(clearError())}
            ></button>
          </div>
        )}

        <div className="card">
          <div className="card-body">
            {isLoading ? (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <MedicationSheetList
                records={medicationSheets}
                onAdd={canCreate ? handleAdd : null}
                onEdit={canEdit ? handleEdit : null}
                onDelete={canDelete ? handleDelete : null}
              />
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default MedicationSheets;